<template>
  <dx-modal :value="show" title="Estornar movimento" size="md" @input="close()"
            id="modal-cash-register-reverse">
    <div class="columns" v-if="entry">
      <div class="column col-12 form-group">
        <div class="stenci-group stenci-alert reverse-help">
          <fa-icon :icon="['fal', 'exclamation-triangle']" class="mr-1"/>
          O estorno cria um movimento inverso de <strong>{{ value | currency }}</strong>
          na sua sessão atual. Pagamentos em dinheiro saem da gaveta agora;
          parcelas de cartão em aberto são canceladas e saldo em conta é devolvido.
        </div>
      </div>
      <div class="column col-12 form-group">
        <label class="form-label">Movimento</label>
        <input type="text" class="form-input" readonly
               :value="entryLabel">
      </div>
      <div class="column col-12 form-group" :class="{'has-error': $v.form.reason.$error}">
        <label class="form-label">Motivo</label>
        <textarea class="form-input" v-model="form.reason" rows="3"
                  placeholder="Obrigatório. Fica registrado no extrato e no comprovante."
                  @blur="$v.form.reason.$touch()"></textarea>
        <template v-if="$v.form.reason.$error">
          <div class="form-input-hint">Informe o motivo</div>
        </template>
      </div>
    </div>
    <template slot="footer">
      <button class="btn btn-error btn-icon btn-icon-left mr-1"
              :class="{loading: saving}" :disabled="saving" @click="save">
        <fa-icon :icon="['fal', 'undo']"/>Estornar
      </button>
      <button class="btn" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    entry: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      form: {
        reason: '',
      },
    };
  },
  computed: {
    entryLabel() {
      const { entry } = this;
      const owner = entry.patient || entry.entity;
      return `${entry.code} · ${owner ? owner.name : ''}`;
    },
    value() {
      if (!this.entry) return 0;
      return this.entry.type === 'receipt' ? this.entry.totals.paid : this.entry.value;
    },
  },
  validations: {
    form: {
      reason: { required },
    },
  },
  methods: {
    save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.saving = true;
      const payload = { reason: this.form.reason };
      this.$http.post(`/cash-register/entries/${this.entry.id}/reverse`, payload)
        .then(({ data }) => {
          this.$toast.success('Movimento estornado.');
          this.$emit('saved', data);
          this.close(true);
        })
        .catch((e) => {
          this.$toast.error(e);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    close(saved = false) {
      this.$emit('close', saved);
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
#modal-cash-register-reverse {
  .reverse-help {
    font-size: $font-size-sm;
    margin: 0;
  }
}
</style>
